import React from 'react'
import IcoMoon, { IconComponent } from 'react-icomoon'
const iconSet = require('./selection.json')

const Icon: typeof IconComponent = (props) => (
  <IcoMoon className='orelo-icon' iconSet={iconSet} {...props} />
)

export default Icon
